import domReady from '@wordpress/dom-ready';
import { createRoot } from '@wordpress/element';
import './style.scss';
import {SimulationTeaser} from "./components/SimulationTeaser";
import {useStore} from "./hooks/store";
import Loading from "react-loading";
import './summaryInjection.js';

const FinancialSimulation = () => {

    const loaded = useStore((state) => state.loaded);
    const valid = useStore((state) => state.valid);

    return (
        <>
            {
                loaded ?
                    valid && <SimulationTeaser /> :
                    <Loading type={"spin"} color={"#58B0D8"} width={30} height={30} />
            }
        </>
    );
}

domReady( () => {
    const root = createRoot(
        document.getElementById( 'app' )
    );

    root.render( <FinancialSimulation /> );
} );